import { Field } from "react-final-form";
import { LabSelector } from "../../../../components/inputs/final_form/LabSelector";
import { PayorSelector } from "../../../../components/inputs/final_form/PayorSelector";
import { ClinicSelector } from "../../../../components/inputs/final_form/ClinicSelector";
import { TestSelector } from "../../../../components/inputs/final_form/TestSelector";
import { LoadingButton } from "../../../../components/LoadingButton";
import { SelectInput } from "../../../../components/inputs/final_form/SelectInput";
import { AdministrateSelectInput } from "../../../components/inputs/AdministrateSelectInput";
import { required } from "../../../../util/validators";
import { classificationOptions } from "../OnshoreConfigurationIndex";
import { useMemo } from "react";
import { compact, omitBy, isNil } from "lodash-es";

const labsToOptions = (labs) => compact(labs).map((lab) => ({ label: lab.labName, value: lab.id }));
const clinicsToOptions = (clinics) => compact(clinics).map((clinic) => ({ label: clinic.clinicName, value: clinic.id }));
const payorsToOptions = (payors) => compact(payors).map((payor) => ({ label: payor.name, value: payor.id }));
const testsToOptions = (tests) => compact(tests).map((test) => ({ label: test.commercialName, value: test.id }));
const codesToOptions = (codes) => compact(codes).map((code) => ({ label: code.code, value: code.id }));

export const OnshoreConfigurationForm = ({ form, handleSubmit, submitting, initialValues, values, ...rest }) => {
  const initialOptions = useMemo(
    () => ({
      lab: labsToOptions([initialValues.lab]),
      clinic: clinicsToOptions([initialValues.clinic]),
      payor: payorsToOptions([initialValues.payor]),
      test: testsToOptions([initialValues.test]),
      codes: codesToOptions(initialValues.cptCodes),
    }),
    [initialValues]
  );

  return (
    <>
      <Field initialOptions={initialOptions.lab} label="Lab" component={LabSelector} isClearable name="labId" valueKey="id" />

      <Field initialOptions={initialOptions.clinic} label="Clinic" component={ClinicSelector} isClearable name="clinicId" valueKey="id" />

      <Field initialOptions={initialOptions.payor} component={PayorSelector} isClearable resource="Payor" label="Payor" name="payorId" />

      <Field
        initialOptions={initialOptions.test}
        resourceUrl={`/admin/tests.json?${new URLSearchParams(
          omitBy(
            {
              "test[direction]": "asc",
              "test[order]": "commercial_name",
              lab: values.labId,
              clinic_id: values.clinicId,
              archived: "false",
            },
            isNil
          )
        )}`}
        label="Test"
        kept={true}
        component={TestSelector}
        isClearable
        name="testId"
        labelSelector="commercial_name"
        key={`test-${values.labId}-${values.clinicId}`}
      />

      <Field
        component={AdministrateSelectInput}
        initialOptions={initialOptions.codes}
        resourceUrl="/admin/cpt_codes.json"
        label="Codes"
        name="cptCodeIds"
        isMulti
        valueKey="id"
      />

      <Field
        label="Classification"
        component={SelectInput}
        name="classification"
        options={classificationOptions}
        validate={required}
        required
      />

      <LoadingButton loading={submitting} onClick={handleSubmit}>
        Submit
      </LoadingButton>
    </>
  );
};
